"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminInstructorServiceAreaMapController = /** @class */ (function () {
    function AdminInstructorServiceAreaMapController(SchoolsModel, UserService, FlashService) {
        var _this = this;
        this.SchoolsModel = SchoolsModel;
        this.FlashService = FlashService;
        this.mapData = {};
        this.loading = true;
        var schoolId = UserService.getCurrentUser().school_id;
        SchoolsModel.getInstructorServiceAreaMap(schoolId)
            .then(function (response) {
            _this.mapData = response;
            _this.loading = false;
        })
            .catch(function () {
            _this.loading = false;
            _this.FlashService.setMessage({
                type: "error",
                message: "Failed to load the instructor service area map.",
            });
        });
    }
    return AdminInstructorServiceAreaMapController;
}());
AdminInstructorServiceAreaMapController.$inject = [
    "SchoolsModel",
    "UserService",
    "FlashService",
];
exports.default = AdminInstructorServiceAreaMapController;
